import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-525ff67b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-question__title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-question__title__asterisk" }, " *", -1))
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["aria-invalid"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["checked", "id", "name", "aria-labelledby", "onChange", "value"]
const _hoisted_7 = ["for"]

import { InterviewQuestionResponseModel, Variant } from '@/models/QuestionModels'
import { useInterviewStore } from '@/stores/interviewStore'
import FlatButton from '@/components/Shared/FlatButton.vue'
import { computed, onMounted, ref } from 'vue'
import { scrollToElementBottom } from '../scrollToElementBottom';


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioButtonQuestion',
  props: {
    question: null,
    isStandAlone: { type: Boolean, default: true }
  },
  emits: ['handleAnswerChoose'],
  setup(__props: any, { emit: emits }) {

const props = __props as { question: InterviewQuestionResponseModel, isStandAlone: boolean };

const interviewStore = useInterviewStore()

const answer = ref<Variant | undefined>(undefined);
const isSubmited = ref<boolean>(false)

const root = ref<HTMLElement | undefined>(undefined);
onMounted(() => scrollToElementBottom(root!.value as HTMLElement));




const nextBtnText = computed(() => interviewStore.getLocalization('InterviewQuestionary.Common.NextQuestionButton'))
const isSubmitable = computed(() => !!answer.value?.Value)

function onAnswerChoose(btn: Variant) {
    const value = btn.Value || btn.Label;

    if (!(value && props.question.Id)) {
        return;
    }

    answer.value = btn
    answer.value.Value = value

    emits('handleAnswerChoose', btn)

    if (isSubmited.value) {
        submitQuestion();
    }
}

function submitQuestion() {
    if (!isSubmitable.value || (interviewStore.isLastQuestion && interviewStore.checkError())) {
        return;
    }

    interviewStore.changeAnswer(props.question.Id, answer.value?.Value!);

    if (!isSubmited.value) {
        interviewStore.nextQuestion();
    }

    isSubmited.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "tw-question radio-question"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(__props.question.Title), 1),
      _hoisted_2
    ]),
    (!!__props.question.Description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: __props.question.Description,
          class: "tw-question__description"
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("fieldset", {
      lass: "radio-question__group",
      "aria-required": true,
      "aria-invalid": !_unref(isSubmitable)
    }, [
      _createElementVNode("legend", {
        id: __props.question.Id + '_label',
        class: "d-none"
      }, _toDisplayString(__props.question.Label), 9, _hoisted_5),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.question.Variants, (btn, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "radio-question__variant-item",
          key: `${__props.question.Id}_${index}`
        }, [
          _createElementVNode("input", {
            class: "radio-question__input",
            type: "radio",
            checked: btn.Label === answer.value?.Label,
            id: __props.question.Id+btn.Label,
            name: __props.question.Id+'radio',
            "aria-labelledby": __props.question.Id + '_label',
            onChange: ($event: any) => (onAnswerChoose(btn)),
            value: btn
          }, null, 40, _hoisted_6),
          _createElementVNode("label", {
            for: __props.question.Id+btn.Label,
            class: "radio-question__variant-label"
          }, _toDisplayString(btn.Label), 9, _hoisted_7)
        ]))
      }), 128))
    ], 8, _hoisted_4),
    (__props.isStandAlone && _unref(isSubmitable) && !isSubmited.value)
      ? (_openBlock(), _createBlock(FlatButton, {
          key: 1,
          onClick: submitQuestion,
          modelValue: _unref(nextBtnText),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(nextBtnText) ? (nextBtnText).value = $event : null)),
          bgColor: '#2C267A',
          isArrowStyle: true
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})